import React from 'react'; //eslint-disable-line
import Grid from '@mui/material/Grid';
import { change, Field } from 'redux-form';
import TextFormField from '../../../../shared/forms/fields/TextFormField';
import SelectFormField from '../../../../shared/forms/fields/SelectFormField';
import { logLevelOptions } from '../../../../types/logLevel';
import MenuItem from '@mui/material/MenuItem';
import { SMSC_FORM_NAME } from '../../../../store/form/formStateModel';
import { useAppDispatch } from '../../../../store/hooks';

const generateSmscLogFile = (smscId: string): string => `smsc_${smscId}.log`;

type Props = {
  readonly readOnly: boolean;
}

const SmscConfigFields = (props: Props) => {
  const { readOnly } = props;
  const dispatch = useAppDispatch();

  const changeSmscLogFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const smscId = event.target.value;

    dispatch(change(SMSC_FORM_NAME, 'logFile', generateSmscLogFile(smscId)));
  };

  return (
    <Grid container spacing={4} style={{ paddingTop: 20 }}>
      <Grid item xs={6}>
        <Field
          fullWidth
          disabled={readOnly}
          label='Smsc ID'
          name='smscId'
          onChange={changeSmscLogFile}
          component={TextFormField}
          required
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          fullWidth
          label='Log file'
          name='logFile'
          component={TextFormField}
          helperText='Self-generated based on smsc ID'
          disabled
          required
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          fullWidth
          disabled={readOnly}
          label='Log level'
          name='logLevel'
          component={SelectFormField}
          required
        >
          { logLevelOptions.map(logLevel => (
            <MenuItem key={logLevel} value={logLevel}>{logLevel}</MenuItem>
          ))}
        </Field>
      </Grid>
    </Grid>
  );
};

export default SmscConfigFields;
